export const MY_PROFILE_ROUTES = {
  activities: '/my-profile/development/activities',
  basicData: '/my-profile/basic-data',
  dashboard: '/my-profile/dashboard',
  development: '/my-profile/development/plan',
  tasks: '/my-profile/tasks',
} as const;

export const TOPBAR_HEIGHT = 64;
